export const ProviderGeocodingBreadCrumbsData = {
    providerGeocodingList: [
      {
        title: "Provider Geocoding List",
        to: "/providerGeocoding",
      },
      {
        title: "Provider Geocoding Portal",
        to: "/providerGeocoding",
      },
    ],
    newProviderGeocodingList: [
      {
        title: "Provider Geocoding List",
        to: "/providerGeocoding",
      },
      {
        title: "Provider Geocoding Portal",
        to: "/providerGeocoding",
      },
      {
        title: null,
      },
    ],
    editProviderGeocodingList: [
      {
        title: "Provider Geocoding List",
        to: "/providerGeocoding",
      },
      {
        title: "Provider Geocoding Portal",
        to: "/providerGeocoding",
      },
      {
        title: "edit",
      },
    ],
    cloneProviderGeocodingList: [
      {
        title: "Provider Geocoding List",
        to: "/providerGeocoding",
      },
      {
        title: "Provider Geocoding Portal",
        to: "/providerGeocoding",
      },
      {
        title: "Clone",
      },
    ],
    uploadProviderGeocodingList: [
      {
        title: "Provider Geocoding List",
        to: "/providerGeocoding",
      },
      {
        title: "Upload",
      },
    ],
  };
  